<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="success"
          icon
          v-bind="attrs"
          v-on="on"
          @click="show = true"
        >
          <v-icon alt="Bearbeiten">
            mdi-pencil-outline
          </v-icon>
        </v-btn>
      </template>
      <span>Bearbeiten</span>
    </v-tooltip>
    <v-dialog
      v-model="show"
      width="550"
    >
      <v-card>
        <v-card-title
          class="pa-0"
        >
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Absender-Adresse bearbeiten</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="show = false"
              >
                <v-icon large>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="mt-4 text-body-1">
          <div class="pb-4">
            <p>
              Die Absender-Adresse kann nicht geändert werden, wenn sie einmal erstellt wurde. Allerdings können Sie eine neue
              Absender-Adresse anlegen, falls Sie eine andere E-Mail-Adresse nutzen möchten.
            </p>
            <v-form
              v-model="valid"
              @submit.prevent="createSender"
            >
              <v-text-field
                v-model="name"
                autofocus
                label="Name"
                outlined
                :rules="[rules.required]"
              />
              <v-text-field
                v-model="fromEmail"
                disabled
                :rules="[rules.email, rules.required]"
                outlined
                label="Absender-Adresse"
                required
              />
              <v-text-field
                v-model="replyToEmail"
                :rules="[rules.email]"
                outlined
                label="Antwort-Adresse"
              />
            </v-form>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            text
            @click="show = false"
          >
            Abbrechen
          </v-btn>
          <v-spacer />

          <v-btn
            color="success"
            :disabled="isLoading"
            :loading="isLoading"
            text
            @click="createSender"
          >
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import HOPPERMATION_SENDER from './queries/HoppermationSenders.gql'
import UPDATE_HOPPERMATION_SENDER from './queries/UpdateHoppermationSender.gql'
import eventBus, { eventNames } from '@/lib/eventBus'
import { email, required } from '@/lib/validation'

export default {
  props: {
    sender: { type: Object, required: true }
  },
  data () {
    return {
      rules: { email, required },
      show: false,
      isLoading: false,
      valid: false,
      name: this.sender.name,
      fromEmail: this.sender.fromEmail,
      replyToEmail: this.sender.replyToEmail
    }
  },
  methods: {
    async createSender () {
      if (!this.valid) {
        return
      }
      try {
        this.isLoading = true
        await this.$apollo.mutate({
          mutation: UPDATE_HOPPERMATION_SENDER,
          variables: {
            input: {
              senderId: this.sender.id,
              name: this.name,
              replyToEmail: this.replyToEmail
            }
          },
          refetchQueries: [{
            query: HOPPERMATION_SENDER,
            variables: { companyId: this.$auth.user.companyId }
          }]
        })
        eventBus.$emit(eventNames.SHOW_SNACKBAR, { color: 'success', text: 'Absender-Adresse gespeichert.' })
        this.show = false
      } catch (e) {
        eventBus.$emit(eventNames.SHOW_SNACKBAR, { color: 'error', text: 'Problem beim Speichern.' })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
